import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  curatorMetadataSelector,
  selectAddMetadataObjectName,
  selectMetadataByTitle,
  setAddMetadataObjectName,
  toggleEditMetadata,
  updateMetadataTitle,
} from '../../../../redux/slicers/admin/curatorMetadataSlicer';
import { useUnityContext } from '../../../container/unityContainer';
import { actions } from '../../../../redux/slicers/admin/curatorMetadataSlicer';
import { useInfoDialogaActions } from '../../../../hooks/useInfoDialogaActions';
import { errorToast, infoToast, successToast } from '../../../../helpers/toastHelper';
import { getAppState } from '../../../../redux/store';
import { undoRedo } from '../UndoRedo/UndoRedo';
import { UnityEvent, waitForEventOnce } from '../../../../helpers/unityPubSub';
import { setCuratorNotSaved } from '../../../../pages/admin/curator/curatorState';
import { setObjectSelectionActive } from '../../../../redux/slicers/admin/curatorSlicer';
//import { captureException } from '@sentry/react';

export const useUnityMetadataListeners = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    window.OnMetadataAdded = (dataJson) => {
      try {
        const data = JSON.parse(dataJson);
        dispatch(actions.addMetadata(data));
        dispatch(setAddMetadataObjectName(null));
      } catch (error) {
        //captureException(error);
        console.error(error);
      }
    };

    window.ShowAddMetadataPopup = (enabled, objectName) => {
      dispatch(setAddMetadataObjectName(objectName));
      dispatch(setObjectSelectionActive(false));
    };
  }, []);
};



export const useUnityMetadata = () => {
  const dispatch = useDispatch();
  const unityContext = useUnityContext();
  const { metadata } = useSelector(curatorMetadataSelector);
  const { openInfoDialog } = useInfoDialogaActions();

  const onAddIntent = () => {
    unityContext.metadataModule.OnAddMetadataButtonClickReceiver();
    // TOOD: use info toast here
    infoToast('Select an object');
  };

  const addMetadata = ({ name }) => {
    const objectName = selectAddMetadataObjectName(getAppState());
    unityContext.metadataModule.AddMetadataReceiver({
      metadataName: name,
      objectName,
    });
    successToast('Metadata added successfully');
    undoRedo.metadata.addMetadata({ title: name, objectName })
    setCuratorNotSaved();
  };

  const forceDeleteMetadata = async (metadataOrTitle) => {
    let metadata = metadataOrTitle;
    if (typeof metadataOrTitle === 'string') {
      // we're deleting by title
      metadata = selectMetadataByTitle(getAppState(), metadataOrTitle);
    }

    const status = await waitForEventOnce(UnityEvent.OnDeleteRoomMetadata, () => {
      unityContext.metadataModule.DeleteMetadataReceiver(metadata.title);
    })

    if (status !== 1) {
      errorToast('Something went wrong during metadata deletion');
      return;
    } else {
      successToast('Metadata has been deleted');
    }

    dispatch(actions.deleteMetadata(metadata));
    undoRedo.metadata.deleteMetadata({ metadata })
    setCuratorNotSaved();
  }

  const deleteMetadata = (metadata) => {
    openInfoDialog({
      title: `Delete "${metadata.title}"?`,
      buttonText: 'Yes',
      cancelButtonText: 'No',
      onButtonClick: () => {
        forceDeleteMetadata(metadata)
      },
    });
  };

  const selectMetadata = (metadata) => {
    unityContext.metadataModule.SelectMetadataReceiver(metadata.title);
  };

  const updateMetadata = async (metadata, newTitle) => {
    const status = await waitForEventOnce(UnityEvent.OnEditMetadataComplete, () => {
      unityContext.metadataModule.EditMetadataReceiver(metadata.title, newTitle);
    })

    if (status !== 1) {
      errorToast('Something went wrong during metadata update');
      return;
    } else {
      successToast('Metadata saved');
    }

    // update store data
    dispatch(
      updateMetadataTitle({
        title: metadata.title,
        newTitle,
      })
    );
    dispatch(toggleEditMetadata({ title: newTitle }));

    // undo/redo
    undoRedo.metadata.changeTitle({ metadata, newTitle })
    setCuratorNotSaved();
  };

  const cancelAddMetadata = () => {
    dispatch(setAddMetadataObjectName(null));
    unityContext.metadataModule.CloseFocusObjectReceiver();
  };

  return {
    metadata,

    addMetadata,
    onAddIntent,
    updateMetadata,
    deleteMetadata,
    forceDeleteMetadata,
    selectMetadata,
    cancelAddMetadata,
  };
};
